// removed by extract-text-webpack-plugin
module.exports = {"wrapper-radio-button":"magazines_15AsO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RadioButton/styles.scss
// module id = 1123
// module chunks = 1